import React, { useState, useEffect } from 'react';
import type { GlobalType } from 'types/GlobalType';
import Logo from 'assets/svg/headerlogo.svg';
import { Menu, ModalComponent } from 'components';

import { Link } from 'gatsby';
import { useScrollDirection } from 'hooks/useScrollDirection';
import ReactMarkdown from 'react-markdown';
import { GatsbyImage } from 'gatsby-plugin-image';
import { SocialIcons } from 'components/SocialIcons/SocialIcons';

interface HeaderProps {
  data: GlobalType;
}

export const Header: React.FC<HeaderProps> = ({ data }) => {
  const pagePopupData = data?.strapiGlobal?.pagePopup;
  const image = pagePopupData?.image?.localFile?.childImageSharp
    ?.gatsbyImageData as
    | import('gatsby-plugin-image').IGatsbyImageData
    | undefined;
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const scrollDirection = useScrollDirection();
  const headerNavClass = isMenuOpen ? 'active' : '';
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 150) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    });
    document.body.classList.toggle('menu-open', isMenuOpen);
  }, [isMenuOpen]);

  const [isModal, setisModal] = useState(true);
  const [displayPopUp, setDisplayPopUp] = useState(false);
  useEffect(() => {
    const seenPopUp = window.sessionStorage.getItem('seenPopUp');
    if (!seenPopUp) {
      setisModal(true);
      setDisplayPopUp(true);
    }
  }, []);

  const closeModal = () => {
    setisModal(false);
  };
  return (
    <>
      {displayPopUp && pagePopupData && (
        <ModalComponent
          isModal={isModal}
          closesModal={closeModal}
          className={`home-popup ${image ? 'home-popup-image' : ''}`}
        >
          <div className="modal-content">
            <h3>{pagePopupData?.title}</h3>
            <ReactMarkdown>
              {pagePopupData?.description?.data?.description ?? ''}
            </ReactMarkdown>
          </div>
          {image && (
            <GatsbyImage
              image={image}
              alt=""
              className="modal-image"
              objectFit="contain"
            />
          )}
        </ModalComponent>
      )}
      <header
        className={`header ${headerNavClass} ${
          scrollDirection === 'down' ? '' : 'sticky'
        } ${isMenuOpen ? 'sticky' : ''} ${scrolled ? 'scrolled' : ''}`}
      >
        <div className="header-bar">
          <div className="header-logo">
            <Link to="/">
              <Logo className="logo" />
            </Link>
            <SocialIcons
              socialMediaLinks={data.strapiGlobal?.socialMediaLinks || {}}
            />
          </div>
          <div className="header-right">

            <Menu setIsMenuOpen={setIsMenuOpen} data={data} />
          </div>
          <button
            type="button"
            className="hamburger-menu close-btn"
            onClick={toggleMenu}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </header>
    </>
  );
};
